import { render, staticRenderFns } from "./disassembleDetail2.vue?vue&type=template&id=56fd80b8&scoped=true&"
import script from "./disassembleDetail2.vue?vue&type=script&lang=js&"
export * from "./disassembleDetail2.vue?vue&type=script&lang=js&"
import style0 from "./disassembleDetail2.vue?vue&type=style&index=0&id=56fd80b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd80b8",
  null
  
)

export default component.exports